import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataTable.VendorCell`

export default defineMessages({
  vendorRequestPendingStatusLabel: {
    id: `${scope}.vendorRequestPendingStatusLabel`,
    defaultMessage: 'Vendor requested',
  },
})
